export default __webpack_public_path__ + "static/media/banner-mobile2.7dc88c8d.png";